import React from 'react';
import Modal from '@amzn/meridian/modal';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Divider from '@amzn/meridian/divider';
import PropTypes from 'prop-types';
import {
  SUBMIT_BUTTON_PROPERTIES,
  FEEDBACK_FORM_PROPERTIES,
} from '../constants/FeedbackConstants';
import RequiredQuestionTypeComponentList from './RequiredQuestionTypeComponentList';
import SkippableFooter from './SkippableFooter';
import NonSkippableFooter from './NonSkippableFooter';

const TriggeredFeedback = ({
  open,
  isDisabled,
  onClose,
  onClickFooterButton,
  title,
  description,
  questions,
  submitButtonSize,
  submitButtonType,
  submitButtonText,
  isSkippable,
  prePopulate,
}) => {
  return (
    <>
      <Modal
        title={title}
        open={open}
        scrollContainer="viewport"
        closeLabel="Close"
        describedById="modal-description"
        width="700px">
        <Column spacingInset="medium">
          <Text id="modal-description">{description}</Text>
          <Divider size="small" />
          <RequiredQuestionTypeComponentList
            questions={questions}
            prePopulate={prePopulate}
          />
        </Column>
        <>
          {isSkippable ? (
            <SkippableFooter
              onClose={onClose}
              isDisabled={isDisabled}
              onClickFooterButton={onClickFooterButton}
              submitButtonSize={submitButtonSize}
              submitButtonText={submitButtonText}
              submitButtonType={submitButtonType}
            />
          ) : (
            <NonSkippableFooter
              isDisabled={isDisabled}
              onClickFooterButton={onClickFooterButton}
              submitButtonSize={submitButtonSize}
              submitButtonText={submitButtonText}
              submitButtonType={submitButtonType}
            />
          )}
        </>
      </Modal>
    </>
  );
};

TriggeredFeedback.propTypes = {
  open: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickFooterButton: PropTypes.func.isRequired,
  questions: PropTypes.array.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  submitButtonSize: PropTypes.string,
  submitButtonType: PropTypes.string,
  submitButtonText: PropTypes.string,
  isSkippable: PropTypes.bool,
  prePopulate: PropTypes.object.isRequired,
};

TriggeredFeedback.defaultProps = {
  title: FEEDBACK_FORM_PROPERTIES.title,
  description: FEEDBACK_FORM_PROPERTIES.description,
  submitButtonSize: SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: SUBMIT_BUTTON_PROPERTIES.text,
  isSkippable: true,
};

export default TriggeredFeedback;
